/**
 * PDD - Affichage des offres auto-gift hors panier (fiche produit + cartes).
 *
 * Une regle `zax.auto_gift_rules` portant un `fixedPrice` remise un variant des que
 * ses conditions sont remplies (ex. « 5 EUR au lieu de 14,90 EUR des 29 EUR
 * d'achat »). Cette remise est appliquee par la Function discount-pdd, donc elle
 * n'existe QUE sur une ligne de panier : hors panier, Shopify ne connait que le prix
 * catalogue, et la fiche produit affichait donc 14,90 EUR alors que le panier
 * facturait bien 5 EUR.
 *
 * Ce module comble l'ecart cote affichage uniquement. Il ne calcule aucune remise :
 * il consomme les offres eligibles publiees par component-auto-gift-rules.js
 * (evenement `auto-gift:offers` + `window.AutoGiftOffers`), calculees par le meme
 * evaluateur de conditions que la decision panier. Les libelles sont pre-rendus par
 * snippets/price.liquid en data-attributs, donc formates par Liquid.
 *
 * Regle d'affichage retenue : RIEN tant que le panier ne remplit pas les conditions.
 * On n'annonce jamais un prix qui ne serait pas facture.
 *
 * Le badge « -XX% » n'est pas gere ici : dopp-discount-badge.js lit les prix affiches
 * et se recalcule seul sur nos mutations.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-auto-gift-offer-variant]';

  function isEligible(priceEl, offers) {
    var gid = priceEl.dataset.autoGiftOfferVariant;
    return offers.some(function (o) { return o.variantId === gid; });
  }

  // Le span « Economisez X » n'existe dans le Liquid que si le produit a un
  // compare_at_price. On le cree au besoin, au meme endroit que Liquid (frere de
  // .price__container), et on le retire s'il est de nous.
  function ensureSaveEl(priceEl) {
    var el = priceEl.querySelector('.price__discount-amount');
    if (el) return el;
    el = document.createElement('span');
    el.className = 'price__discount-amount';
    el.dataset.autoGiftOfferOwned = '1';
    priceEl.appendChild(el);
    return el;
  }

  // N'ecrit que si le texte differe. Deux effets : on ne mute pas le DOM a chaque
  // passage (donc on ne relance pas en boucle notre propre MutationObserver), et on
  // reprend la main des qu'un tiers a ecrase notre valeur.
  function setText(el, text) {
    if (el.textContent.trim() !== text) el.textContent = text;
  }

  // Reconcilie l'affichage avec l'offre, sans garde « deja applique ».
  //
  // D'autres acteurs reecrivent ce meme DOM : sidecart appelle
  // variantSelects.reset() apres CHAQUE mutation du panier — dont celles que le
  // moteur auto-gift declenche lui-meme en ajoutant un cadeau — et les remises
  // Regios repassent sur les prix affiches. Un flag « deja fait » nous empechait de
  // reprendre la main apres leur passage : le prix remise s'affichait puis
  // disparaissait definitivement (visible surtout quand l'article etait deja au
  // panier, car le moteur y declenche plus de mutations).
  function apply(priceEl) {
    var sale = priceEl.querySelector('.price__sale .price-item--sale');
    var struck = priceEl.querySelector('.price__sale s.price-item--regular');
    // Structure inattendue (variantes aux compare_at heterogenes) : on s'abstient
    // plutot que d'afficher un prix a moitie reecrit.
    if (!sale || !struck) return;

    // Etat hors offre sauvegarde une seule fois : aux passages suivants on relirait
    // nos propres valeurs.
    if (priceEl.dataset.autoGiftOfferApplied !== '1') {
      var existingSave = priceEl.querySelector('.price__discount-amount');
      priceEl.dataset.autoGiftOfferSaleBackup = sale.textContent;
      priceEl.dataset.autoGiftOfferStruckBackup = struck.textContent;
      priceEl.dataset.autoGiftOfferSaveBackup = existingSave ? existingSave.textContent : '';
      priceEl.dataset.autoGiftOfferWasOnSale = priceEl.classList.contains('price--on-sale') ? '1' : '0';
      priceEl.dataset.autoGiftOfferApplied = '1';
    }

    setText(struck, priceEl.dataset.autoGiftOfferStruck);
    setText(sale, priceEl.dataset.autoGiftOfferPrice);
    setText(ensureSaveEl(priceEl), priceEl.dataset.autoGiftOfferSave);
    if (!priceEl.classList.contains('price--on-sale')) priceEl.classList.add('price--on-sale');
  }

  function revert(priceEl) {
    if (priceEl.dataset.autoGiftOfferApplied !== '1') return;

    var sale = priceEl.querySelector('.price__sale .price-item--sale');
    var struck = priceEl.querySelector('.price__sale s.price-item--regular');
    if (sale) sale.textContent = priceEl.dataset.autoGiftOfferSaleBackup || '';
    if (struck) struck.textContent = priceEl.dataset.autoGiftOfferStruckBackup || '';

    var save = priceEl.querySelector('.price__discount-amount');
    if (save) {
      if (save.dataset.autoGiftOfferOwned === '1') save.remove();
      else save.textContent = priceEl.dataset.autoGiftOfferSaveBackup || '';
    }

    if (priceEl.dataset.autoGiftOfferWasOnSale !== '1') priceEl.classList.remove('price--on-sale');
    delete priceEl.dataset.autoGiftOfferApplied;
  }

  var currentOffers = [];

  function render() {
    document.querySelectorAll(SELECTOR).forEach(function (priceEl) {
      if (isEligible(priceEl, currentOffers)) apply(priceEl);
      else revert(priceEl);
    });
  }

  // Garde d'idempotence : deux appels attacheraient deux listeners et deux
  // observers, qui feraient le meme travail en double.
  var started = false;

  function start() {
    if (started) return;
    started = true;

    // Le moteur a pu publier avant notre chargement : on reprend l'etat courant
    // plutot que d'attendre le prochain cart:update.
    if (Array.isArray(window.AutoGiftOffers)) currentOffers = window.AutoGiftOffers;
    render();

    document.body.addEventListener('auto-gift:offers', function (event) {
      currentOffers = (event.detail && event.detail.offers) || [];
      render();
    });

    // Les blocs de prix sont re-rendus sans passer par cart:update : changement de
    // variante (product-info.js re-rend la section), pagination/filtres de
    // collection, cartes injectees par Depict. Throttle (et non debounce) : sur une
    // page vivante les mutations ne se calment jamais, un debounce ferait trainer le
    // prix. Meme approche que dopp-discount-badge.js.
    var lastRun = 0;
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        lastRun = Date.now();
        render();
      }, Math.max(0, 100 - (Date.now() - lastRun)));
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Expose pour tests / debug manuel (pendant de window.AutoGiftCart).
  window.AutoGiftOfferPrice = { render: render, apply: apply, revert: revert };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
